import { Directive, ElementRef } from '@angular/core';
@Directive({
  selector: '[appMask]',
})
export class MaskDirective {
  constructor(private eleRef: ElementRef) {
    this.eleRef.nativeElement.setAttribute('', '');
  }
}
